import React from "react";
import { createElementClass } from "../helpers";
export var Break = function Break() {
  return React.createElement("br", {
    className: createElementClass("break")
  });
};